import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/service/alert.service';
import { ArquivoService } from 'src/app/service/arquivo.service';
import { ClientesService } from 'src/app/service/clientes.service';

@Component({
  selector: 'app-cadastrar-shape',
  templateUrl: './cadastrar-shape.component.html',
  styleUrls: ['./cadastrar-shape.component.css']
})
export class CadastrarShapeComponent implements OnInit {
  fazendaForm!: FormGroup;
  clienteId: string | null = localStorage.getItem('cliente');
  clientes: Array<{ id: number, nome: string }> = [];
  geojsonData?: string | null;
  coordenadasGeojson: any;
  estaCarregando = false;
  estaEnviando: boolean = false;
  arquivoSelecionado: File | null = null;
  fazenda = { sr_id: 0, vc_descricao: '', vc_arquivo: '' };
  botaoDesabilitado: boolean = false;
  mensagemEnvio: string = '';
  clienteSelecionado: any = null;
  clientesCarregando = true;
  public clientesFormatados: any[] = [];
  private intervaloMensagem: any;
  private mensagens: string[] = [
    'Aguarde um momento...',
    'Estamos registrando seu shape...',
    'Isso pode demorar um pouco...'
  ];
  private indiceMensagem: number = 0;

  @Output() geojsonDataEmitter = new EventEmitter<any>();

  constructor(
    private formBuilder: FormBuilder,
    private alertService: AlertService,
    private arquivoService: ArquivoService,
    private router: Router,
    private clienteService: ClientesService
  ) { }

  ngOnInit(): void {
    this.criarForm();
    this.buscarClientes();
  }

  buscarClientes(): void {
    this.clientesCarregando = true;

    this.clienteService.listarServiceClientes().subscribe({
      next: (resp: any[]) => {
        this.clientesFormatados = resp.map(cliente => ({
          id: cliente.sr_id,
          nome: cliente.vc_nome,
          latitude: cliente.vc_latitude,
          longitude: cliente.vc_longitude
        }));
        
        const clienteStorage = localStorage.getItem('cliente');

        if (clienteStorage) {
          const clienteId = Number(clienteStorage);
          const clienteCompleto = this.clientesFormatados.find(c => c.id === clienteId);
          
          if (clienteCompleto) {
            this.clienteSelecionado = clienteCompleto;

            this.fazendaForm.patchValue({
              fk_cliente: clienteId
            });
          } else {
            console.warn('Cliente do localStorage não encontrado na lista');
          }
        }
        this.clientesCarregando = false;
      },
      error: (error) => {
        this.clientesCarregando = false;

        if (error.status === 401) {
          localStorage.removeItem('token');
          this.router.navigate(['/']);
        } else {
          this.alertService.error('Erro ao carregar clientes');
        }
      }
    });
  }

  onClienteSelecionadoCadastro(clienteId: number | string): void {
    if (typeof clienteId === 'number') {
      this.fazendaForm.patchValue({
        fk_cliente: clienteId
      });
      
      const clienteEncontrado = this.clientesFormatados.find(c => c.id === clienteId);
      
      if (clienteEncontrado) {
        this.clienteSelecionado = clienteEncontrado;
      }
    } else {
      this.fazendaForm.patchValue({
        fk_cliente: null
      });
      this.clienteSelecionado = null;
    }
  }

  criarForm(): void {
    this.fazendaForm = this.formBuilder.group({
      fk_cliente: ['', Validators.required],
      arquivo: [null],
    });
  }

  submit(): void {
    if (this.estaEnviando) return;
    this.estaEnviando = true;
    this.cadastrar();
  }

  cadastrar(): void {
    const formData = new FormData();
    const clienteId = this.fazendaForm.get('fk_cliente')?.value
    const arquivo = this.fazendaForm.get('arquivo')?.value;
    if (arquivo) {
      formData.append('geojson', arquivo);
    }
    this.estaEnviando = true;
    this.iniciarMensagensEnvio();

    this.arquivoService.cadastrar(formData, clienteId).subscribe(
      (resp: any) => {
        this.alertService.success('Shape cadastrado com sucesso');
        this.pararMensagensEnvio();
        this.voltar();
      },
      err => {
        this.alertService.error(err.message, 'Erro ao cadastrar o shape');
        this.pararMensagensEnvio();
        this.estaEnviando = false;
      }
    ).add(() => {
      this.estaEnviando = false;
      this.pararMensagensEnvio();
    });
  }

  private iniciarMensagensEnvio(): void {
    this.indiceMensagem = 0;
    this.mensagemEnvio = this.mensagens[this.indiceMensagem];
    this.intervaloMensagem = setInterval(() => {
      this.indiceMensagem = (this.indiceMensagem + 1) % this.mensagens.length;
      this.mensagemEnvio = this.mensagens[this.indiceMensagem];
    }, 7000);
  }

  private pararMensagensEnvio(): void {
    if (this.intervaloMensagem) {
      clearInterval(this.intervaloMensagem);
      this.intervaloMensagem = null;
      this.mensagemEnvio = '';
    }
  }

  voltar(): void {
    this.router.navigateByUrl('/configuracao/shapes');
  }

  get mensagemErroCampo(): (campo: string) => string | null {
    return (campo: string) => {
      const control = this.fazendaForm.get(campo);
      if (!control || !control.invalid || (!control.dirty && !control.touched)) {
        return null;
      }
      if (control.hasError('required')) {
        return `Campo obrigatório.`;
      }
      return `Campo inválido.`;
    };
  }

  carregarGeoJsonDoS3(s3Url: string): void {
    fetch(s3Url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao carregar arquivo GeoJSON.');
        }
        return response.json();
      })
      .then(geojsonData => {
        this.geojsonData = geojsonData;
        this.coordenadasGeojson = this.extraiAsCoordenadasDoArquivoGeoJson(geojsonData);
        this.geojsonDataEmitter.emit(this.coordenadasGeojson);
        this.estaCarregando = false;
      })
      .catch(error => {
        this.alertService.error('Erro ao carregar GeoJSON: ' + error.message);
      })
  };

  aoAlterarArquivo(evento: any): void {
    const file: File = evento.target.files[0];

    if (!file) {
      return;
    }

    const maxSizeInBytes = 100 * 1024 * 1024;
    if (file.size > maxSizeInBytes) {
      const fileSizeInMB = (file.size / (1024 * 1024)).toFixed(2);
      this.alertService.error(`O arquivo possui ${fileSizeInMB}MB e excede o limite de 100MB.`);
      this.arquivoSelecionado = null;
      this.botaoDesabilitado = true;
      return;
    }

    if (file.type === 'application/geo+json' || file.name.endsWith('.json') || file.name.endsWith('.geojson')) {
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        try {
          const result = e.target?.result as string;
          const jsonData = JSON.parse(result);
          if (this.isValidGeoJson(jsonData)) {
            this.fazendaForm.get('arquivo')?.setValue(file);
            this.fazendaForm.get('arquivo')?.setErrors(null);
            this.arquivoSelecionado = file;
            this.geojsonData = jsonData;
            this.geojsonDataEmitter.emit(jsonData);
            this.coordenadasGeojson = this.extraiAsCoordenadasDoArquivoGeoJson(jsonData);
            this.botaoDesabilitado = false;
          } else {
            this.alertService.error('O arquivo GeoJson está em formato inválido.');
            this.botaoDesabilitado = true;
          }
        } catch (error) {
          this.alertService.error('Erro ao processar o arquivo JSON/GeoJSON. Verifique o formato do arquivo.');
          this.arquivoSelecionado = null;
          this.botaoDesabilitado = true;
        }
      };
      reader.readAsText(file);
    } else {
      this.alertService.error('Por favor, selecione um arquivo JSON ou GeoJSON válido.');
      this.arquivoSelecionado = null;
      this.botaoDesabilitado = true;
    }
  }

  public isValidGeoJson(geojson: any): boolean {
    if (!geojson || geojson.type !== 'FeatureCollection') return false;

    return geojson.features.every((feature: any) => {
      const props = feature.properties ?? {};
      const geom = feature.geometry;

      const tipoValido = geom && (geom.type === 'Polygon' || geom.type === 'MultiPolygon');
      const propriedadesValidas = props.FAZENDA && props.TALHAO;
      return tipoValido && propriedadesValidas;
    });
  }

  private extraiAsCoordenadasDoArquivoGeoJson(geojson: any): any {
    if (!geojson || !geojson.features || geojson.features.length === 0) return null;

    const coordinates = geojson.features.flatMap((feature: any) => {
      if (feature.geometry.type === 'Polygon') {
        return feature.geometry.coordinates[0];
      } else if (feature.geometry.type === 'MultiPolygon') {
        return feature.geometry.coordinates.flatMap((polygon: number[][][]) => polygon[0]);
      }
      return [];
    });
    return coordinates;
  }

  aoArrastar(evento: DragEvent, addClass: boolean): void {
    evento.preventDefault();
    const dragDropArea = evento.target as HTMLElement;
    addClass ? dragDropArea.classList.add('dragover') : dragDropArea.classList.remove('dragover');
  }

  aoSoltar(evento: DragEvent): void {
    evento.preventDefault();
    evento.stopPropagation();
    this.aoArrastar(evento, false);

    const file = evento.dataTransfer?.files[0];
    if (file) {
      const fakeEvent = { target: { files: [file] } };
      this.aoAlterarArquivo(fakeEvent);
    }
  }
}
